import React from 'react';

function SearchError({ message }) {
    return (
        <div className="flex flex-col items-center justify-center py-10 px-6 gap-2">
            <div className="w-12 h-12 rounded-2xl bg-[#FFF3F3] flex items-center justify-center text-2xl">
                🔍
            </div>
            <p className="m-0 text-[14px] font-semibold text-[#222222]">{message}</p>
        </div>
    );
}

export default SearchError;
